import { render } from "./InstructionsComponent.vue?vue&type=template&id=71255cfc&scoped=true"
import script from "./InstructionsComponent.vue?vue&type=script&lang=js"
export * from "./InstructionsComponent.vue?vue&type=script&lang=js"

import "./InstructionsComponent.vue?vue&type=style&index=0&id=71255cfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71255cfc"]])

export default __exports__